module.exports = "<div class=\"csi-property-view-flat\">\n    <div data-dojo-attach-point=\"containerNode\" />\n</div>"